// extracted by mini-css-extract-plugin
export default {"brandPromo":"hI-z","carousel":"iI-z"};